import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
const TEAM_NAME_ATTRIBUTE_EXAMPLE = "cn";
const GROUP_SEARCH_PATTERN_EXAMPLE = "(objectClass=group)";
const GROUP_SEARCH_BASE_EXAMPLE = "ou=people,dc=example,dc=com";
const TeamNameAttribute = () => {
  const { t } = useTranslation("enterprise_authentication");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "active_directory.group_sync_wizard_config.team_name_attribute",
      values: { productName, example: TEAM_NAME_ATTRIBUTE_EXAMPLE },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ));
};
const GroupSearchPattern = () => {
  const { t } = useTranslation("enterprise_authentication");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "active_directory.group_sync_wizard_config.group_search_pattern",
      values: { productName, example: GROUP_SEARCH_PATTERN_EXAMPLE },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ));
};
const GroupSearchBase = () => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "active_directory.group_sync_wizard_config.group_search_base",
      values: { example: GROUP_SEARCH_BASE_EXAMPLE },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ));
};
const TeamDefaultRoles = () => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement("span", null, t("active_directory.group_sync_wizard_config.team_default_roles"));
};
const help = {
  groupSearchBase: /* @__PURE__ */ React.createElement(GroupSearchBase, null),
  groupSearchPattern: /* @__PURE__ */ React.createElement(GroupSearchPattern, null),
  teamNameAttribute: /* @__PURE__ */ React.createElement(TeamNameAttribute, null),
  teamDefaultRoles: /* @__PURE__ */ React.createElement(TeamDefaultRoles, null)
};
const excludedFields = {
  teamUniqueIdAttribute: true
};
const initialValues = {
  teamNameAttribute: "cn",
  groupSearchPattern: "(objectClass=group)"
};
export default { help, excludedFields, initialValues };
